
import React from 'react'
import LayoutModal from '../../Layout/Dashboard/LayoutModal'
import FormStaticInfo from './FormStaticInfo'
import { InitialValues, getDataToSend, getInitialValues, getValidationSchema } from './formUtil'
import { usePageState } from '../../lib/state mangment/LayoutPagestate'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useUpdateStaticInfo } from '../../api/StaticInfo'

function EditStaticInfoModal() {
  const {objectToEdit} = usePageState()
  const {status, mutate} = useUpdateStaticInfo();

  const handleSubmit = (value:InitialValues)=>{
    const dataToSend = getDataToSend({...value})
    
    mutate(dataToSend)
}
  
  return (
    <LayoutModal 
     isAddModal={false}
     getInitialValues={getInitialValues(objectToEdit)} 
     handleSubmit={handleSubmit}
     status={status as QueryStatusEnum}
     headerText='Edit Modal' 
     getValidationSchema={getValidationSchema(objectToEdit)}>
      <FormStaticInfo isDisable={true}/>
    </LayoutModal>
  )
}

export default EditStaticInfoModal
